import * as yup from "yup"
import { Citta } from "../../types"

export function initialValuesCitta(citta?: Citta | undefined) {
  if (citta) {
    return citta
  }
  return {
    nome: "",
    lon: undefined,
    lat: undefined,
  }
}

export function validationSchemaCitta() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
